import { render, staticRenderFns } from "./vendor-settlements.vue?vue&type=template&id=5430bd3e&"
import script from "./vendor-settlements.vue?vue&type=script&lang=js&"
export * from "./vendor-settlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports